import type {JSX} from 'react'
import {Navigate} from 'react-router-dom'
import {StorageService} from '../service/storage.services'
import useAppStore from '../store'

export default function ProtectedRoute({children}: {children: JSX.Element}) {
  const user = useAppStore(state => state.user)
  const authAccess = StorageService.getAuthAccess()

  if (user === null && authAccess === null) {
    return <Navigate to='/auth/login' />
  }
  return children
}
